/* eslint-disable react/no-array-index-key */
// import { AnimatePresence } from 'framer-motion';
import {
  Flex,
  Stack,
  useBreakpointValue,
  IconButton,
  MenuItem,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
// import { useTimer } from 'use-timer';
import EpisodeFull from 'src/components/common/card/episode-full';
// import { MotionBox } from 'src/components/motion-box';
// import { motion, isValidMotionProp, MotionProps } from 'framer-motion';
import SvgArrowLeft from 'src/components/icons/arrow-left';
import SvgArrowRight from 'src/components/icons/arrow-right';
import { logger } from 'src/lib/logger';
import { useArticlePin } from 'src/app/article/hooks/use-pin';
// import { usePagerButton } from 'src/components/pager-button';
import type { ListType } from 'src/service/creation';
import { IconMenu } from 'src/components/icon-menu/icon-menu';
import Carousel from 'nuka-carousel';

interface Props {
  isOwner: boolean;
  isLoaded: boolean;
  data: ListType[];
}

export function CreatorPick({ isOwner, isLoaded, data }: Props) {
  const isEmpty = data.length === 0;
  if (!isLoaded) {
    return (
      <div className="reppl-container-width animate-pulse mt-16">
        <div className="h-96 skeleton-line bg-white" />
      </div>
    );
  }

  if (isEmpty && !isOwner) {
    return null;
  }
  if (isEmpty && isOwner) {
    return (
      <div className="section-empty rounded-md text-center flex items-center h-96">
        <p className="flex-1 text-center">You did not pick any episodes.</p>
      </div>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={4}
      justifyContent="center"
      position="relative"
      display={{ base: 'contents', md: 'flex' }}
      overflow="hidden"
      px={4}
      className="pin-creations"
    >
      <CreatorPickCard data={data} isOwner={isOwner} isLoaded={isLoaded} />
    </Stack>
  );
}

// const variants = {
//   enter: (direction: number) => {
//     return {
//       x: direction > 0 ? 500 : -500,
//       opacity: 0,
//     };
//   },
//   center: {
//     zIndex: 1,
//     x: 0,
//     opacity: 1,
//   },
//   exit: (direction: number) => {
//     return {
//       zIndex: 0,
//       x: direction < 0 ? 500 : -500,
//       opacity: 0,
//     };
//   },
// };
// const swipeConfidenceThreshold = 5000;
// const swipePower = (offset: number, velocity: number) => {
//   return Math.abs(offset) * velocity;
// };

function CreatorPickCard({
  isOwner,
  isLoaded,
  data,
}: {
  isLoaded: boolean;
  isOwner: boolean;
  data: ListType[];
}) {
  const [cards, setCards] = useState<ListType[]>(data);
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
  });
  // const pager = usePagerButton(cards.length);
  // const current = cards[pager.step];
  const { mutateAsync: createPin } = useArticlePin();
  // const [whileDrag, setWhileDrag] = useState(false);

  // const timer = useTimer({
  //   autostart: true,
  //   interval: 50000,
  //   onTimeUpdate: (time) => {
  //     if (cards.length > 0 && time > 0) {
  //       pager.next();
  //     }
  //   },
  // });
  async function removePinned(content: any) {
    const { contentID: eid, sourceID: rid } = content;
    try {
      await createPin({
        dataset: [
          {
            contentID: eid,
            pinned: false,
            type: 'pin',
          },
        ],
        projectID: rid,
        contentType: 'EPISODE',
      });

      // if (pager.direction === -1) {
      //   return;
      // }

      // if (pager.hasPrevious) {
      //   pager.prev();
      // } else {
      //   pager.next();
      // }
    } catch (err) {
      logger.error(err);
    }
  }

  useEffect(() => {
    setCards(data);
  }, [data]);

  if (!isLoaded) {
    return null;
  }

  return (
    <Flex
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      w="100%"
      px="15px"
      pb={2}
    >
      {cards.length > 0 && (
        <Flex
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          height="410px"
          margin={{ base: 0, md: '0 30px' }}
        >
          {/* isMobile && (
            <>
              <IconButton
                onClick={(event) => {
                  pager.prev();
                  event.stopPropagation();
                }}
                className="hover-arrow"
                zIndex="10"
                boxShadow="-1px 1px #F3F3F4"
                bg="#FFF"
                color="#242526"
                aria-label="previous-page"
                borderRadius={100}
                position="absolute"
                margin="auto"
                left="15px"
                top={0}
                bottom={0}
                border="1px solid #F3F3F4"
                icon={<SvgArrowLeft fontSize="24px" />}
              />
              <IconButton
                onClick={(event) => {
                  pager.next();
                  event.stopPropagation();
                }}
                className="hover-arrow"
                zIndex="10"
                boxShadow="1px 1px #F3F3F4"
                bg="#FFF"
                color="#242526"
                aria-label="next-page"
                borderRadius={100}
                position="absolute"
                margin="auto"
                right="15px"
                top={0}
                bottom={0}
                border="1px solid #F3F3F4"
                icon={<SvgArrowRight fontSize="24px" />}
              />
            </>
          ) */}
          <Flex position="relative" width="100%">
            {/*
            <AnimatePresence initial={false} custom={pager.direction}>
              <motion.div
                key={pager.step}
                custom={pager.direction}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{
                  x: { type: 'spring', stiffness: 300, damping: 30 },
                  opacity: { duration: 0.2 },
                }}
                drag="x"
                position="absolute"
                left={0}
                className="w-full"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={1}
                onHoverStart={() => timer.pause()}
                onHoverEnd={() => timer.start()}
                onMouseDown={(e) => e.preventDefault()}
                onDrag={() => {
                  if (!whileDrag) {
                    setWhileDrag(true);
                  }
                }}
                onDragEnd={(e, { offset, velocity }) => {
                  setWhileDrag(false);
                  const swipe = swipePower(offset.x, velocity.x);

                  if (swipe < -swipeConfidenceThreshold) {
                    pager.next();
                  } else if (swipe > swipeConfidenceThreshold) {
                    pager.prev();
                  }
                }}
              >
                <EpisodeFull
                  data={current}
                  menu={
                    isOwner && (
                      <IconMenu zIndex={1} color="#DADADA">
                        <MenuItem
                          color="$mode.900"
                          fontWeight="semibold"
                          onClick={async (event) => {
                            event.stopPropagation();
                            await removePinned(current);
                          }}
                        >
                          Remove Creator&apos;s Pick
                        </MenuItem>
                      </IconMenu>
                    )
                  }
                />
              </motion.div>
            </AnimatePresence>
          */}
            <Carousel
              autoplay={cards.length > 1}
              wrapAround
              renderCenterLeftControls={({ previousSlide }) => {
                if (!isMobile && cards.length > 1) {
                  return (
                    <IconButton
                      onClick={previousSlide}
                      className="hover-arrow"
                      zIndex="10"
                      boxShadow="-1px 1px #F3F3F4"
                      bg="#FFF"
                      color="#242526"
                      aria-label="previous-page"
                      borderRadius={100}
                      position="absolute"
                      margin="auto"
                      left="-19px"
                      top={0}
                      bottom={0}
                      border="1px solid #F3F3F4"
                      icon={<SvgArrowLeft fontSize="24px" />}
                    />
                  );
                }
              }}
              renderCenterRightControls={({ nextSlide }) => {
                if (!isMobile && cards.length > 1) {
                  return (
                    <IconButton
                      onClick={nextSlide}
                      className="hover-arrow"
                      zIndex="10"
                      boxShadow="1px 1px #F3F3F4"
                      bg="#FFF"
                      color="#242526"
                      aria-label="next-page"
                      borderRadius={100}
                      position="absolute"
                      margin="auto"
                      right="-19px"
                      top={0}
                      bottom={0}
                      border="1px solid #F3F3F4"
                      icon={<SvgArrowRight fontSize="24px" />}
                    />
                  );
                }
              }}
              defaultControlsConfig={{
                pagingDotsClassName: 'mr-2',
                pagingDotsContainerClassName: `${
                  cards.length > 1 ? 'dots' : 'noDots'
                } -left-6`,
              }}
            >
              {cards.map((d, key) => {
                const mkey = `ca_${key}`;
                return (
                  <EpisodeFull
                    key={mkey}
                    data={d}
                    menu={
                      isOwner && (
                        <IconMenu zIndex={1} color="#DADADA">
                          <MenuItem
                            color="$mode.900"
                            fontWeight="semibold"
                            onClick={async (event) => {
                              event.stopPropagation();
                              await removePinned(d);
                            }}
                          >
                            Remove Creator&apos;s Pick
                          </MenuItem>
                        </IconMenu>
                      )
                    }
                  />
                );
              })}
            </Carousel>
            <style jsx global>{`
              .dots {
                position: absolute !important;
                top: 22px !important;
                margin: auto !important;
              }
              .noDots {
                display: none !important;
              }
            `}</style>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}

// function Dots({
//   length = 3,
//   as,
//   activeIndex,
//   ...props
// }: { length: number; activeIndex?: number } & StackProps) {
//   return (
//     <HStack spacing="6px" {...props}>
//       {Array.from({ length }).map((_, i) => (
//         <Box
//           key={i}
//           width="6px"
//           height="6px"
//           borderRadius="3px"
//           as={as}
//           bg={activeIndex === i ? 'gray.600' : 'gray.300'}
//         />
//       ))}
//     </HStack>
//   );
// }
